export const validate = (registrationTypeList) => (values) => {
  const errors = {};

  if(!values.title) { 
    errors.title = "Title is required"
  }

  if (!values.firstName) {
    errors.firstName = "First Name is required";
  }

  if (!values.lastName) {
    errors.lastName = "Last Name is required";
  }

  if (!values.userEmail) {
    errors.userEmail = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.userEmail)) {
    errors.userEmail = "Invalid email address";
  } else if (values.userEmail.toLowerCase() !== values.confirmEmail.toLowerCase()) {
    errors.confirmEmail = "Email addresses must match";
  }

  if (values.mobile && !/^\d{1,12}$/.test(values.mobile)) {
    errors.mobile = "Mobile should contains digits only with max 12 digits.";
  }

  if (!values.country || values.country === "0") {
    errors.country = "Country is required";
  }

  if (!values.affiliation) {
    errors.affiliation = "Affiliation is required";
  }

  if (!values.registrationType) {
    errors.registrationType = "Registration Type is required";
  } else {
    const member = registrationTypeList.find(
      (item) =>
        item.showAdditionalField && item.registrationType === values.registrationType
    );
    if (member && !values.membershipNumber) {
      errors.membershipNumber = "Membership Number is required for the selected Registration Type";
    }
  }
  if(values.isAuthor &&  (values.noOfPapers === "0" || !values.noOfPapers)){
    errors.noOfPapers = "Number of Papers is required";
  }

  return errors;
};